/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styles from './NetworkErrorToast.module.css';

export default function NetworkErrorToast() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      const msg = event?.reason?.message || event?.message || '';
      if (
        msg.includes('Failed to fetch') ||
        msg.includes('Lock broken') ||
        msg.includes('NetworkError') ||
        msg.includes('AbortError')
      ) {
        setVisible(true);
        setTimeout(() => setVisible(false), 5000);
      }
    };
    window.addEventListener('unhandledrejection', handler);
    return () => window.removeEventListener('unhandledrejection', handler);
  }, []);

  if (!visible) return null;

  return (
    <div className={styles.netToast} style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      zIndex: 'var(--z-toast)', display: 'flex', alignItems: 'center', gap: 'var(--space-md)',
      background: 'var(--text)', border:'var(--border-thin) solid var(--gold)', borderRadius:'var(--radius-md)',
      padding: 'var(--space-md) var(--space-xl)', fontFamily: "'Montserrat', sans-serif",
      minWidth: 300, animation: 'slideUp 0.2s ease',
    }}>
      <div style={{ width: 6, height: 6, borderRadius:'var(--radius-pill)', background: 'var(--gold)', flexShrink: 0 }} />
      <div>
        <div style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--weight-medium)', letterSpacing: 'var(--tracking-wider)', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 'var(--space-2xs)'}}>
          Connection Issue
        </div>
        <div style={{ fontSize: 'var(--text-xs)', color: 'var(--sandstone)', lineHeight: 1.5 }}>
          Please check your internet connection and try again.
        </div>
      </div>
      <button onClick={() => setVisible(false)}
        style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 'var(--text-md)', cursor: 'pointer', padding: '0 0 0 var(--space-sm)', flexShrink: 0, lineHeight: 'var(--lh-tight)' }}>
        ×
      </button>
    </div>
  );
}
